import React from 'react';
import _get from "lodash/get";
import {Link, useLocation} from "react-router-dom";
import ReactHtmlParser from 'react-html-parser';
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import ButtonBase from "@material-ui/core/ButtonBase";
import Icon from "@material-ui/core/Icon";
import {PAGES_SLUGS} from "../constants";
import clsx from "clsx";
import Skeleton from "@material-ui/lab/Skeleton";
import {getWishlistData, WL} from "../helpers/localStorage";
import listingCardGeneralStyles from "../theme/listingCardGeneralStyles";

const ProductCardVariantTwo = (props) => {
    const classes = useStyles();
    const location = useLocation();

    return <ButtonBase
        focusRipple
        component={Link}
        to={{pathname: `/${PAGES_SLUGS.DETAILS}/${props.slug}`, state: {from: location.pathname}}}
        className={classes.root}
    >
        <div
            className={classes.imageWrapper}
        >
            <img data-src={props.image} className={clsx("swiper-lazy", classes.image)}/>
            {getWishlistData(WL.CAR).includes(props.slug) &&
            <div className={classes.wishlistHeart}>
                <Icon className={`${classes.wlIcon} brand-icon-heart-fill`}/>
            </div>}
            <Skeleton variant={'rect'} width="100%" height={"100%"}
                      className={"preloader-skeleton"}/>
            {_get(props, "sku", false) && <Typography className={classes.sku}># {props.sku}</Typography>}
        </div>
        <div className={classes.body}>
            <div>
                <Typography paragraph className={classes.title}>{ReactHtmlParser(props.title)}</Typography>
            </div>
            <div>
                <Typography component={'div'} className={classes.text}>
                    <span className={classes.priceText}>Începând de la:</span><br/>
                    <span className={classes.price}>{props.price} <sup className={classes.tva}></sup> </span>
                    {props.oldPrice && <div>
                        <span
                            className={classes.oldPrice}>{props.oldPrice}</span>
                        {props.discount && <span className={classes.oldPriceDiscount}> (-{props.discount}%)</span>}
                    </div>}
                </Typography>
            </div>
        </div>
    </ButtonBase>
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        display: "block",
    },
    imageWrapper: {
        width: "100%",
        paddingTop: "56%",
        position: "relative",
        background: "#fff",
        borderRadius: "8px",
        overflow: "hidden",
    },
    image: {
        // objectFit: "cover",
        // objectPosition: '50% 50%',
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        transform: "scale(1.01)",
        transition: "transform 300ms",
        "&:hover": {
            transform: "scale(1.08)",

        }
    },
    sku: {
        position: "absolute",
        bottom: theme.spacing(1),
        left: theme.spacing(1),
        fontWeight: theme.typography.fontWeightLight,
        fontSize: theme.typography.pxToRem(12),
        lineHeight: theme.typography.pxToRem(12),
        // color:"#707070",
        color: "#fff",
    },
    body: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },

    title: {
        fontSize: 20,
        fontWeight: "400",
        letterSpacing: "0px",
        lineHeight: "1.2",
        ".contrast-section &": {
            color: "#fff",
        }
    },
    text: {
        fontSize: "18px",
        lineHeight: "24px",
        letterSpacing: 0,
        fontWeight: 300,
        ".contrast-section &": {
            color: "#fff",
        }
    },
    priceText:{
        fontSize: "14px",
        lineHeight: "20px",
        color:"#707070",
    },
    tva:{
        fontSize: "28px",
        lineHeight: "1",
        [theme.breakpoints.down('sm')]: {
            fontSize: "16px",
            lineHeight: "1",
        },
    },
    price: {
        fontWeight: 700,
        fontSize: "28px",
        lineHeight: "1",
        color: '#1C6BBA',
        [theme.breakpoints.down('sm')]: {
            fontSize: "20px",
            lineHeight: "1",
        },
        ".contrast-section &": {
            color: "#fff",
        }
    },
    oldPrice: {
        fontSize: "14px",
        lineHeight: "24px",
        letterSpacing: 0,
        fontWeight: 300,
        textDecoration: "line-through",
      /*  "&:before": {
            content: `""`,
            display: "inline-block",
            width: "10px"
        }*/
    },
    oldPriceDiscount: {
        fontSize: "14px",
        lineHeight: "24px",
        letterSpacing: 0,
        fontWeight: 300,
        "&:before": {
            content: `""`,
            display: "inline-block",
            width: "5px"
        }
    },
    link: {
        fontSize: "14px",
        lineHeight: "1",
        padding: `${theme.spacing(1) / 2}px`,
        position: "relative",
        cursor: "pointer",
        "&:hover": {
            textDecoration: "none",
        },
        "&:before": {
            content: `''`,
            position: "absolute",
            width: "0",
            height: "1px",
            bottom: 0,
            left: "50%",
            transform: "translateX(-50%)",
            background: theme.palette.primary.main,
            transition: theme.transitions.create(['width'], {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        "&:hover:before": {
            content: `''`,
            position: "absolute",
            width: "100%",
            height: "1px",
            bottom: 0,
            left: "50%",
            transform: "translateX(-50%)",
            background: theme.palette.primary.main
        }
    },
    icon: {
        fontSize: 10,
    },
    wishlistHeart: {
        ...listingCardGeneralStyles(theme).wishlistHeart
    },
    wlIcon: {
        ...listingCardGeneralStyles(theme).wlIcon
    }
}));
export default ProductCardVariantTwo;
